// extracted by mini-css-extract-plugin
export default {"left-col":"left-col_dIXcb","right-col":"right-col_Oas7P","filter-bar":"filter-bar_xwMhR","coupon-list-space":"coupon-list-space_jBMZd"};